import {
  Card,
  HStack,
  IconButton,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import BulletPointsIcon from "../../plugin/components/common/icons/BulletPointsIcon";
import BulletNumbersIcon from "../../plugin/components/common/icons/BulletNumbersIcon";
import BoldIcon from "../../plugin/components/common/icons/BoldIcon";
import ItalicIcon from "../../plugin/components/common/icons/ItalicIcon";

/**
 * Renders the observation form
 * 
 * @returns The observation form
 */
const ObservationForm = () => {
  const { t } = useTranslation();

  return (
    <VStack height={"full"}>
      <Card padding={"8px"} width={"full"} backgroundColor={"#CED0D0"}>
        <HStack width={"full"} alignItems={"flex-start"}>
          <IconButton colorScheme="gray" backgroundColor={"transparent"} icon={<BulletPointsIcon />} color="#5B5F61" />
          <IconButton colorScheme="gray" backgroundColor={"transparent"} icon={<BulletNumbersIcon />} color="#5B5F61" />
          <IconButton colorScheme="gray" backgroundColor={"transparent"} icon={<BoldIcon />} color="#5B5F61" />
          <IconButton colorScheme="gray" backgroundColor={"transparent"} icon={<ItalicIcon />} color="#5B5F61" />
        </HStack>
      </Card>
      <Textarea placeholder={t("beneficiaryFile.form.observation.placeholder")} borderRadius={"10px"} color={"gray.400"} backgroundColor={"#2D313A"} height={"full"} />
    </VStack>
  );
};

export default ObservationForm;
